<div class="flex items-center mb-4">
    <div class="ml-auto mr-auto">
        <p-selectbutton [options]="tabs" [ngModel]="aba()" (ngModelChange)="aba.set($event)" optionLabel="name" optionValue="value" [unselectable]="true" class="flex flex-wrap justify-center gap-2" styleClass="permissoes-tabs"> </p-selectbutton>
    </div>
</div>

<!-- @if, não [hidden]: esconder não é gatear. Com [hidden] o componente monta, dispara
     GET /api/roles e mantém os botões de CRUD vivos no DOM para quem não pode usá-los. -->
@if (podeCatalogo) {
    <app-roles-catalogo [hidden]="aba() !== 'catalogo'"></app-roles-catalogo>
}
@if (podeAdministrar) {
    <app-perfis-catalogo [hidden]="aba() !== 'perfis'" (abrirEditor)="onAbrirEditorPerfil($event)"></app-perfis-catalogo>
    <app-atribuir-roles [hidden]="aba() !== 'atribuir'"></app-atribuir-roles>
}
@if (podeDiagnostico) {
    <app-permissoes-diagnostico [hidden]="aba() !== 'diagnostico'"></app-permissoes-diagnostico>
}

@if (perfilEmEdicao() !== undefined) {
    <app-perfil-detalhe [idPerfil]="perfilEmEdicao() ?? null" (salvou)="onPerfilSalvo()" (fechado)="onPerfilFechado()"></app-perfil-detalhe>
}
